// Lib
import { classicFormat } from '@/hooks/format/useFormatNumber';

import { SIZE_50 } from '@/lib/gridElements/size';
import { TWITTER } from '@/lib/socialProfile';

// Components
import { HalfBarLineChart } from '@/components/composite/Charts/HalfBarLineChart';

export const gainedLostFollowersConfig = {
    title: 'chart.twitter.gained_lost_followers',
    id: 'gained_lost_fans_history',
    margin: {
        left: -25,
        right: -25,
        bottom: 25,
        top: 10
    },
    name: {
        date: 'date',
        gained: 'chart.twitter.gained_lost_followers_gained',
        lost: 'chart.twitter.gained_lost_followers_lost',
        total: 'chart.twitter.gained_lost_followers_total',
        posts: 'chart.twitter.gained_lost_followers_posts'
    },
    tooltip: 'chart.twitter.tooltip_gained_lost_followers',
    social: TWITTER,
    valueFormat: classicFormat,
    orientation: 'horizontal',
    labelLeftAxis: 'followers',
    labelRightAxis: 'chart.post_engagements.posts',
    color: {
        gained: 'green',
        lost: 'gray',
        posts: 'blue'
    },
    legendTypes: {
        gained: 'square',
        lost: 'square',
        posts: 'line'
    },
    size: SIZE_50,
    type: 'chart',
    element: HalfBarLineChart
};
